export default __webpack_public_path__ + "static/avatar-kayi-common-9-detail-053cf22affbcb75d3a4292c7b01d4348.png";